import { render, staticRenderFns } from "./EnergyBoxes.vue?vue&type=template&id=5e2ec660&scoped=true"
import script from "./EnergyBoxes.vue?vue&type=script&lang=js"
export * from "./EnergyBoxes.vue?vue&type=script&lang=js"
import style0 from "./EnergyBoxes.vue?vue&type=style&index=0&id=5e2ec660&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2ec660",
  null
  
)

export default component.exports